import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#a68b4d', // ذهبي غامق
      contrastText: '#fff',
    },
    secondary: {
      main: '#58595B', // أسود داكن
      contrastText: '#fff',
    },
    warning: {
      main: '#b49d6a', // ذهبي فاتح
    },
    info: {
      main: '#BDBEC0', // رمادي فاتح
    },
    background: {
      default: '#fff', // خلفية عامة
      paper: '#f5f2eb', // بيج فاتح جدًا
    },
    text: {
      primary: '#58595B', // أسود داكن
      secondary: '#a68b4d', // ذهبي غامق
    },
    grey: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#eeeeee',
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
    },
    // هنا تضع الخصائص الإضافية مباشرةً داخل palette
    gender: {
      female: '#f48fb1',
      male: '#64b5f6',
    },
    horseColors: {
      GREY: '#9e9e9e',
      CHESTNUT: '#a0522d',
      BAY: '#8b0000',
      BLACK: '#000000',
      DEFAULT: '#a68b4d',
    },
  },
  typography: {
    fontFamily: [
      'Adriana', // خط الهوية (إذا متوفرًا)
      'Segoe UI',
      'SegoeUI',
      'Helvetica Neue',
      'Helvetica',
      'Arial',
      'sans-serif',
    ].join(','),
    fontWeight: 600,
    fontSize: 13,
    fontWeightBold: 'bold',
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          // هذا سيؤثر على جميع TextField، لو أردت فقط للجداول يمكن تخصيصه عبر الكلاس لاحقاً
          backgroundColor: '#fff',
          borderRadius: 3,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff', // خلفية حقل الإدخال
          borderRadius: 3,
        },
        input: {
          backgroundColor: '#fff', // في بعض الحالات يجب وضعها هنا
        },
      },
    },

    MuiTableContainer: {
      styleOverrides: {
        root: {
          width: '100%', // يأخذ كامل عرض الحاوية الأب (Container)
          maxWidth: '100%', // يمنع أي تصغير
          margin: 0, // يلغي الهامش الجانبي
          padding: 0, // يلغي أي padding
          borderRadius: 16, // لو أردت تبقى الزوايا
          boxShadow: 'none', // (اختياري) إذا لا تريد ظل
        },
      },
    },

    MuiTable: {
      styleOverrides: {
        root: {
          width: '100%', // جعل عرض الجدول دائمًا 100%
          minWidth: 800, // الحد الأدنى للعرض (اختياري حسب تصميمك)
          tableLayout: 'auto', // يمكن تغييره إلى 'fixed' إذا أحببت
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          textAlign: 'center',
        },
        head: {
          backgroundColor: '#b49d6a', // اللون الذهبي الفاتح لرؤوس الأعمدة
          color: '#fff', // نص أبيض
          fontWeight: 'bold',
          fontSize: 15,
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          // توحيد لون رأس الجدول
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#b49d6a', // لون رأس الجدول
            color: '#fff', // لون الخط في رأس الجدول
            fontSize: 14,
          },
          // توحيد لون الصفوف (اختياري)
          '& .MuiDataGrid-row': {
            backgroundColor: '#fff', // صفوف عادية
          },
          '& .MuiDataGrid-row:hover': {
            backgroundColor: '#f5f2eb', // صفوف عند المرور عليها
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#b49d6a', // احتياطي لرأس الجدول بالكامل
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#f5f2eb',
          borderRadius: 18,
          boxShadow: '0 1px 8px 0 #e0dac2',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: '#a68b4d',
          color: '#fff',
          '&:hover': {
            backgroundColor: '#b49d6a',
          },
        },
        containedSecondary: {
          backgroundColor: '#58595B',
          color: '#fff',
        },
      },
    },
    MuiContainer: {
      variants: [
        {
          props: { variant: 'form' }, // اسم المتغير المخصص
          style: {
            backgroundColor: '#f9f9f9',
            padding: '32px',
            borderRadius: '16px',
            boxShadow: '0 0 10px rgba(0,0,0,0.1)',
            maxWidth: '700px',
            marginTop: '24px',
            marginBottom: '24px',
            alignItems: 'center', // توسيط جميع العناصر أفقياً

            width: '70% !important',
          },
        },
      ],
      styleOverrides: {
        root: {
          width: '96% !important',
          maxWidth: '96% !important',
          marginLeft: 'auto',
          marginRight: 'auto',
        },
      },
    },

    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#f5f2eb',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: '#a68b4d',
          color: '#fff',
        },
      },
    },
  },
});

export default theme;
